import { atom } from 'jotai';

/** Whether the Foresight Assistant panel is open. Lives outside the section
 *  component so chat-internal components (the panel header's close button) can
 *  import it without a ChatBotSection → ChatBot → ChatHeader import cycle. */
export const ShowChatBotAtom = atom(false);
